
import { Component, Vue } from 'vue-property-decorator';
import { Route } from 'vue-router';
import api from '@/api';
import Util from '@/utils/util';
import Swal from 'sweetalert2';

const { merchantcategory } = api;

@Component({

})
export default class MerchantCategoryList extends Vue {
  private data = { data: [], totalCount: 0, pageSize: 20, pageNo: 0 };

  private loading = false;

  private panel = 0;

  private headers = [
    { text: 'Id', value: 'sequence' },
    { text: '名稱', value: 'categoryName' },
    { text: '編輯', value: 'edit', width: 100 },
    { text: '刪除', value: 'delete', width: 100 },
  ];

  private get totalCount() {
    return this.data.totalCount;
  }

  private get pageCount() {
    return Math.ceil((this.data.totalCount || 0) / (this.data.pageSize || 20));
  }

  private get collection() {
    return [...(this.data.data || [])];
  }

  private filter = {
    pageSize: Util.isNullOrUndefined(this.$route.query.pageSize)
      ? 20
      : +this.$route.query.pageSize,
    pageNo: Util.isNullOrUndefined(this.$route.query.pageNo)
      ? 1
      : +this.$route.query.pageNo,
  };

  private async updatePage(page: number) {
    this.filter.pageNo = page;
    await this.query();
  }

  private async handleDelete(categoryId: any) {
    await Swal.fire({
      title: '您確定要刪除嗎?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: '確定',
      cancelButtonText: '取消',
    }).then(async (result) => {
      if (result.isConfirmed) {
        const { status, message } = await merchantcategory.delete(categoryId);
        if (status === 1) {
          Swal.fire({ icon: 'success', title: '刪除成功' });
          this.query();
        } else {
          Swal.fire({ icon: 'error', title: message });
        }
      }
    });
  }

  private async query() {
    const query = {
      ...this.filter,
      pageSize: `${this.filter.pageSize}`,
      pageNo: `${this.filter.pageNo}`,
    };
    if (this.isQueryChanged(query)) {
      await this.$router.replace({ query });
    } else {
      await this.requestData();
    }
  }

  private async reset() {
    this.filter = {
      pageSize: 20,
      pageNo: 1,
    };
    await this.query();
  }

  private isQueryChanged(query: {
    [key: string]: string | Array<string | null> | null | undefined;
  }): boolean {
    return !Object.keys(query).every(
      (key: string) => query[key]?.toString() === this.$route.query[key],
    );
  }

  private async requestData() {
    this.loading = true;
    const { data } = await merchantcategory.list(this.filter);
    this.data = data;
    this.loading = false;
  }

  private async beforeRouteEnter(
    to: Route,
    from: Route,
    next: (to?: ((vm: MerchantCategoryList) => void) | boolean) => void,
  ) {
    await next(async (vm) => {
      await vm.requestData();
    });
  }

  private async beforeRouteUpdate(
    to: Route,
    from: Route,
    next: (to?: ((vm: MerchantCategoryList) => void) | boolean) => void,
  ) {
    if (to.name === 'merchantCategoryList') await this.requestData();
    await next(true);
  }
}
